const withdrawAgentMode = require('../pix/withdrawAgentMode');

const qrcodeAgentMode = {
  withdrawService: 0,
  businessEstablishment: 1,
  otherService: 2,
  convertToJDPI(agentMode) {
    switch (agentMode) {
      case withdrawAgentMode.WITHDRAW_SERVICE:
        return this.withdrawService;
      case withdrawAgentMode.BUSINESS_ESTABLISHMENT:
        return this.businessEstablishment;
      case withdrawAgentMode.OTHER_SERVICE:
        return this.otherService;
      default:
        throw new Error('Invalid QRCode agent mode to convert to JDPI');
    }
  }
};

module.exports = qrcodeAgentMode;
